import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { url_ws } from 'src/app/config/config';


@Component({
  selector: 'app-mi-perfil',
  templateUrl: './mi-perfil.component.html',
  styleUrls: ['./mi-perfil.component.css']
})
export class MiPerfilComponent implements OnInit {

  public myUrl = url_ws + "users/";
  public user: any;
  public almacenamiento;

  formUser = new UntypedFormGroup ({
    nombre: new UntypedFormControl(''),
    apellidos: new UntypedFormControl(''),
    role: new UntypedFormControl(''),
    status: new UntypedFormControl(1),
    storeageBD: new UntypedFormControl('')
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient) { 
  }

   ngOnInit() {

    this.user = StorageManager.getUser();
    this.getUserId(this.user.id);
    
  }

  public getUserId(id) {

    return new Promise( resolve=> {
      this.http.get(this.myUrl+"getUserId.php?id="+id).toPromise()
      .then((response:any)=>{
        this.formUser.patchValue({
          nombre: response[0].nombre,
          apellidos: response[0].apellidos,
          role: response[0].role,
          observaciones: response[0].observaciones,
          read_only: (response[0].read_only == '1' || response[0].read_only == 1) ? true: false ,
          eliminado: (response[0].eliminado == '1' || response[0].eliminado == 1)? true: false 
        });
        
        this.almacenamiento = response[2].size;
      });
  })
  }

}
